module.exports = __webpack_public_path__ + "img/yibaoli.c25d81e5.png";